export const version = "wordlists/5.0.7";
//# sourceMappingURL=_version.js.map